import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useCurrent } from "../../hooks";
import { MwSpinnerButton } from "../ui";
import { getCustomer } from "../../services/customerService";
import { useTranslation } from "react-i18next";

const ShowCustomer = () => {
  const params = useParams();
  const { currentLangId, currentTenantId } = useCurrent();
  const [customer, setCustomer] = useState();
  const [loading, setLoading] = useState(true);
  const [t] = useTranslation("global");

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      const data = await getCustomer(
        currentTenantId,
        params.companyId,
        params.branchId,
        params.id
      );
      const fullname =
        data?.fullname?.find((item) => item.lang?.trim() === currentLangId)?.text ||
        data?.fullname?.[0]?.text ||
        "";
      setCustomer({ ...data, name: fullname });
      setLoading(false);
    };
    load();
  }, [currentTenantId, params.companyId, params.branchId, params.id, currentLangId]);

  if (loading) {
    return (
      <div className="p-4">
        <MwSpinnerButton withLabel={false} isFullCenter={true} />
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-3">
      <div className="bg-slate-50 text-slate-500 rounded-lg p-3 text-xs">
        <div className="font-bold px-2 pt-3 text-sm text-center">{customer?.name}</div>
        <div className="flex justify-between p-2">
          <span>{t("customers.customerNumber")}</span>
          <span>{customer?.customerNo || t("customers.noData")}</span>
        </div>
        <hr />
        <div className="flex justify-between p-2">
          <span>{t("customers.mobileNumber")}</span>
          <span>{customer?.mobileNo || t("customers.noData")}</span>
        </div>
        <hr />
        <div className="flex justify-between p-2">
          <span>{t("customers.email")}</span>
          <span>{customer?.email || t("customers.noData")}</span>
        </div>
        <hr />
        <div className="flex justify-between p-2">
          <span>{t("customers.notes")}</span>
          <span>{customer?.customerNotes || t("customers.noData")}</span>
        </div>
      </div>
    </div>
  );
};

export default ShowCustomer;
